import { ButtonGroup } from "@vds/buttons";
import { Icon } from "@vds/icons";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Greencontainer, IconStyle, ReviewPageMediumText, ReviewPageSmallText, ReviewPageText } from "../../global/components/OnboardingFormStyles/Styles";
import { CAMERA_ONBOARDING_TEST_IDS } from "./cameraOnboardingConstants";

const ReviewPage2=({cameraName, cameraData})=>{
  const { companionSelected} = useSelector(state => state.cameraonboardingReducer);
  const fieldOfViews = useSelector(state => state.cameraonboardingReducer.fovNames) || [];
  const FOVImages = useSelector(state => state.cameraonboardingReducer.snapshots.images) || [];
  const FOVNames = useSelector(state => state.cameraonboardingReducer.snapshots.id) || [];

  let navigate=useNavigate();
  const cancelButton=()=>{
    navigate("/devices");
  }
  const {siteSelected, floorSelected, areaSelected, subAreaSelected } = useSelector(state => state.cameraonboardingReducer);

  const cvAppLicenseTypeButton=()=>{
    const state = {
      fieldOfViews: fieldOfViews,
      FOVImages: FOVImages,
      FOVNames: fieldOfViews.map(m =>{return m.fovName}),
      FOVId: fieldOfViews.map(m =>{return m.fovId}),
      cameraId: cameraName,
      companionId: companionSelected?.id,
      siteSelected:siteSelected,
      floorSelected:floorSelected,
      areaSelected:areaSelected,
      subAreaSelected:subAreaSelected,
      cameraname:cameraData.name,
      action: "cameraOnBoarding",
      cameradata: cameraData
    }
    navigate("/cvAppsLicenseType", {state: state});
  }


    return(
            <>
            <Greencontainer>
            <ReviewPageText>
            <IconStyle>
            <Icon name="alternate-checkmark" size={"44px"} color="#00B845" />            
            </IconStyle>
            You have successfully onboarded this camera
            </ReviewPageText>
            <ReviewPageMediumText>
            Would you like to continue to activate apps on this camera's streams? 
            </ReviewPageMediumText>
        <ReviewPageSmallText>
        Remember, you can subscribe to and onboard apps at any time through on the Cameras or Camera details pages.            
        </ReviewPageSmallText>
        <ButtonGroup 
            childWidth={"100%"}
            viewport={"desktop"}
            rowQuantity={{ desktop: 2 }}
            data={[
              {
                children: "I'll do it later",
                size: "large",
                use: "secondary",
                state:"default",
                width: "270px",
                onClick: () => cancelButton(),
                "data-testid": CAMERA_ONBOARDING_TEST_IDS.REVIEW_LATER_BUTTON,
              },
              {
                children: "Yes, activate apps now",
                size: "large",
                use: "primary",
                width: "270px",
                onClick: () => cvAppLicenseTypeButton(),
                "data-testid": CAMERA_ONBOARDING_TEST_IDS.REVIEW_ACTIVATE_APPS_BUTTON,
              },
            ]}
            alignment={"centre"}
          />
            </Greencontainer>
            </>

    )

}
export default ReviewPage2;